import styled from 'styled-components'
import media from '../../../../services/generateMediaQueries'
import confetti from '../../../../assets/img/simplified-login/confetti.png'
import {
  Title as DefaultTitle,
  Description as DefaultDescription,
  StyledLink,
} from '../../../simplified.login/components/MainView/MainView.style'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'

export const Title = styled(DefaultTitle)`
  font-family: var(--font-family-ayala-display-sans);
  color: var(--color-secondary);
  // ${media.lessThan('small')`
  //   margin-top: -48px;
  // `}
`
export const Description = styled(DefaultDescription)`
  margin-top: 1rem;
  min-width: 350px;
`
export const LinkOptionsLabel = styled.div`
  text-align: center;
  font-size: 13px;
  margin-top: 5rem;
  span {
    font-weight: 600;
  }
`
export const LinkOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 8px;
  gap: 8px;
  ${media.lessThan('small')`
    flex-direction: column;
  `}
`
export const LinkOption = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
export const LinkOptionImg = styled.img`
  height: 1em;
`
export const LinkOptionButton = styled(ActionButton)`
  width: 200px;
`
export const DownloadOptionsContainer = styled(LinkOptionsContainer)`
  flex-direction: row;
  justify-content: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
`
export const ContinueLink = styled(StyledLink)`
  font-size: 13px;
  text-align: center;
  text-transform: uppercase;
  color: var(--color-secondary);
  margin-top: 5rem;
`
export const TopConfetti = styled.div`
  margin: -80px;
  height: 140px;
  width: calc(100% + 160px);
  transform: rotate(180deg);
  background: url('${confetti}') bottom / contain no-repeat;

  ${media.lessThan('small')`
    display: none;
  `}
`
